/**
 * VERSIONE LIBRERIA 2
 */

/**
 * GMap 
 * oggetto per la gestione di punti geografici che si appoggia su google maps
 * autore : Pier Paolo Ciullo
 * email : ciullo@gmail.com
 **/


function GMapMarker () {
	this.id = null;
	this.address = "";
	this.txt = "";
	this.lat = null;
	this.lng = null;
	this.title = "";
	this.icon = null;
    this.labelClass = null; //Marker con label
    this.labelAnchor = null; //Marker con label
    this.labelContent = null; //Marker con label
	this.googlem = null;  			// riferimento al marker google
	this.draggable = false;
	this.click_callback = null;  	// callback da definire in caso si vuole intercettare il click.
	this.mouseover_callback = null;
	this.mouseout_callback = null;
	this.data = null;	 			// eventuali dati privati custom da associare al marker
	this.infoWindow = null;			// eventuale popup creata
	this.route_address = "";	    // in caso venga calcolato un percorso viene associata il risultato della route calcolata
}


/**
 *
 * @param objName: nome js dichiarato nel codice chiamante, serve per la callback google
 * @param mapOptions : opzioni da passare all'oggetto di googlemaps
 * @returns
 */

function GMap(objName,mapOptions) {
	var self = this;
    this.markerLabel = false;
    this.markerLabelScript = ""; // libreria per la gestione dei marker con css e label
	this.gmap = null;
	this.geocoder = null;
	this.centerAddress = null;  // da settare se vogliamo centrare la mappa ad un certo indirizzo
	this.lat = 42;
	this.lng = 13;
	this.zoom = 6;
	this.elementId = "map_canvas";
	this.objName = objName;
	this.markers = [];
	this.areas = [];
	this.current = 0;
	this.delay = 1000;
	this.infowindowprec = null;
	this.mapTypeId = "ROADMAP";
	//this.googleMarkers = new Array();
	this.directionsService = null;
	this.directionsDisplay = null;
	this.directionsPanelId = null;
	this.language = "it";
	this.queuedMarker = [];
	this.mapOptions = mapOptions?mapOptions:{}; // opzioni della mappa
	this.apiKey = null;//"AIzaSyBoG8WGobCO2OS_GH48eMNj4DFECFc93oA";
	this.version = null; // version libreria gmap, null prende quella corrente
	/**
	 * controlla che se i markers aggiunti con addMarker hanno un indirizzo, invece delle coordinate.
	 * se si, attiva il servizio di geolocalizzazione di google con timeout di 1 secondo per poter fare le 
	 * chiamate in background a fine servizio chiama la successCb
	 * 
	 */
	this.showQueued = function (successCb,errorCb) {
		successCb = successCb?successCb:function () {};
		errorCb = errorCb?errorCb:function () {};
		
		var _showQueued = function () {
			log.info('_showQueued ' + self.queuedMarker.length );
			if (self.queuedMarker.length > 0) {
				var marker = self.queuedMarker.pop();
				self.geocoder.geocode( { 'address': marker.address }, function(results, status) {
					if (results) {
						var foundOk = false;
						$.each(results, function(key, item) {
							if (status==google.maps.GeocoderStatus.OK) {

								var point = new google.maps.LatLng(item.geometry.location.lat(), item.geometry.location.lng());
								marker.lat = item.geometry.location.lat();
								marker.lng = item.geometry.location.lng();
								self.showAddressByPoint(point,marker);
								foundOk = true;
							}
						});
						if (!foundOk) {
							//marker.lat = self.lat;
							//marker.lng = self.lng;
							//self.showMarker(marker);
							var point = new google.maps.LatLng(marker.lat, marker.lng);	
							self.showAddressByPoint(point,marker);
						}
					} else {
						var point = new google.maps.LatLng(marker.lat, marker.lng);	
						self.showAddressByPoint(point,marker);
					}
					setTimeout(function () {
						_showQueued();
					},self.delay);
			   });
			} else {
				successCb();
			}
		}
		log.info('GMap.showQueued ',self.markers)
		for (var i in self.markers) {
			var marker = self.markers[i];
			if (marker.googlem != null)
				continue;
			if (marker.lat && marker.lng) {
				var point = new google.maps.LatLng(marker.lat, marker.lng);	
				self.showAddressByPoint(point,marker);
			} else  {
				if (marker.address != "") {
					self.queuedMarker.push(marker);
				} else {
					var point = new google.maps.LatLng(self.lat, self.lng);
					self.showAddressByPoint(point,marker);
				}
			}
		
		}
		if (self.queuedMarker.length == 0) {
			return successCb();
		}
		
		// chiamata funzione ricorsiva;
		_showQueued();
		
	};
	
	this.updateMarkerAddress = function (index,address,callback) {
		callback=callback?callback:function () {};
		self.geocoder.geocode( { 'address': address }, function(results, status) {
			if (status==google.maps.GeocoderStatus.ZERO_RESULTS) {
				return callback({msg:'Zero risulati',error:1});
			}
			if (results) {
				var found = 0;
				$.each(results, function(key, item) {

					if (status==google.maps.GeocoderStatus.OK && !found) {
						found = 1;
						var point = new google.maps.LatLng(item.geometry.location.lat(), item.geometry.location.lng());
						self.markers[index].lat = item.geometry.location.lat();
						self.markers[index].lng = item.geometry.location.lng();
						self.markers[index].googlem.setPosition(point);
						self.updateArea(index);

					}
				});
				if (found) {
					callback({msg:'',error:0,pos:self.markers[index].googlem.getPosition()});
				} else {
					callback({msg:'Error not found ',error:1,pos:{} });
				}
			} else {
				callback({msg:"errore generale",error:1,pos:{},status:status,result:result});
			}

	   });
	};
	
	this._initialize = function() {
		
		try {
			
			var myLatlng = new google.maps.LatLng(self.lat,self.lng);
			var myOptions = {
					zoom: self.zoom,
					center: myLatlng,
					mapTypeId: google.maps.MapTypeId.ROADMAP
			};

			for (var k in self.mapOptions) {
				myOptions[k] = self.mapOptions[k];
			}
			//console.log(myOptions);
			self.gmap = new google.maps.Map(document.getElementById(self.elementId), myOptions);
			setTimeout(function () {
				self.geocoder = new google.maps.Geocoder();

				if (self.centerAddress) {
					self.geocoder.geocode( { 'address': self.centerAddress }, function(results, status) {
						if (results) {
							$.each(results, function(key, item) {
								if (status==google.maps.GeocoderStatus.OK) {

									var point = new google.maps.LatLng(item.geometry.location.lat(), item.geometry.location.lng());
									self.gmap.setCenter(point);

								}
							});
						}
				   });
				}
				var rendererOptions = {
			      map: self.gmap,
			      suppressMarkers : true,
			      preserveViewport: true
			    };
				self.directionsDisplay = new google.maps.DirectionsRenderer(rendererOptions);
				if (self.directionsPanelId)
					self.directionsDisplay.setPanel(document.getElementById(self.directionsPanelId));
				//self.directionsDisplay.setMap(self.gmap);
				
				//self.showMarkers();
				// events
				google.maps.event.addListener(self.gmap, 'zoom_changed', function() {
					self.zoom_changed();
					//log.info("zoom activate " + self.gmap.getZoom());
				});
				google.maps.event.addListener(self.gmap, 'bounds_changed', function(event) {
					self.bounds_changed(event);
					//log.info("zoom activate " + self.gmap.getZoom());
				});

				self.afterInitialize();
			},500);
			
		} catch (e) {
			log.error(e);
		}
	}
	this.initialize =  function () {
		if (self.markerLabel) {
			self.loadMarkerWithLabelScript(function () {
				self._initialize();
			})
		} else 
			self._initialize();
		
	};

	this.geocodingResults = function (address,callback) {
		self.geocoder.geocode( { 'address': address }, function(results, status) {
			eval(callback + "(results)");
		});
	};

	this.getGeocodingResults = function (address,callback) {
		self.geocoder.geocode( { 'address': address }, function(results, status) {
			callback(results,status);
		});
	};
	this.showAddress = function (address,gmarker) {

		self.geocoder.geocode( { 'address': address }, function(results, status) {
			$.each(results, function(key, item) {
				if (status== google.maps.GeocoderStatus.OK) {
					var point = new google.maps.LatLng(item.geometry.location.lat(), item.geometry.location.lng());
					self.showAddressByPoint(point,gmarker);
				}
			});
		});
		return;
	};

	this.showAddressByPoint = function (point,gmarker) {
		// var index = self.current;  vecchio modo
		var index = self.getIndexById(gmarker.id);
		if (index < 0 ) {
			alert('errore');
			return ;
		}
		
		
		
		
		
		
		
		var params = {
				map:self.gmap,
			    draggable:gmarker.draggable,
			    animation: google.maps.Animation.DROP,
			    position: point,
			    icon : gmarker.icon,
			    title: gmarker.title,
			    optimized : false
		};
		if (gmarker.icon)
			params.icon = gmarker.icon;
		if (gmarker.googlem === null) {
			var marker = null;
            if (self.markerLabel) {
                params.icon = " ";
                params.labelClass = gmarker.labelClass ? gmarker.labelClass : "";
                params.labelAnchor = gmarker.labelAnchor ? gmarker.labelAnchor : new google.maps.Point(25, 25);
                params.labelContent  = gmarker.labelContent;
                marker = new MarkerWithLabel(params);
            } else {
               marker =  new google.maps.Marker(params);
            }
			self.markers[index].googlem = marker;
		} else {
			self.markers[index].googlem.setPosition(point);
			self.markers[index].googlem.setMap(self.gmap);
		}
		self.markers[index].lat = point.lat();
		self.markers[index].lng = point.lng();
		if (gmarker.draggable) {
			var localg = self.markers[index];
			google.maps.event.addListener(localg.googlem, 'dragend', function() {
				var pos = localg.googlem.getPosition();
				localg.lat = pos.lat();
				localg.lng = pos.lng();
				self.updateArea(index);
				self.markerDragend(pos,localg);
			});
		}


		if (gmarker.click_callback) {
			google.maps.event.addListener(self.markers[index].googlem, 'click', function() {
				gmarker.click_callback();
			});
		} else {
			if (gmarker.txt != "") {
				var infowindow = new google.maps.InfoWindow({
					content: gmarker.txt,
					maxWidth:250
				});
				gmarker.infoWindow = infowindow;
				//var index = self.current;
				google.maps.event.addListener(self.markers[index].googlem, 'click', function() {


					if (self.infowindowprec) {
						self.infowindowprec.close(); //chiude la precedente infowindow
					}

					infowindow.open(self.gmap,self.markers[index].googlem); //apre la nuova infowindow
					self.infowindowprec = infowindow; //assegna l'attuale infowindow alla variabile globale
				});
			}
		}
		if (gmarker.mouseover_callback) {
			google.maps.event.addListener(self.markers[index].googlem, 'mouseover', function() {
				gmarker.mouseover_callback();
			});
		}
		if (gmarker.mouseout_callback) {
			google.maps.event.addListener(self.markers[index].googlem, 'mouseout', function() {
				gmarker.mouseout_callback();
			});
		}
		self.markerPositionUpdated(gmarker);
	};

	this.loadScript = function () {
		var self = this;
		var script = document.createElement("script");
		script.type = "text/javascript";
		var src = "http://maps.googleapis.com/maps/api/js?key=" + self.apiKey;
		if (self.version)
			src += "&v="+self.version;
		src += "&callback=" + self.objName + ".initialize&language="+self.language;
		script.src = src;
		document.body.appendChild(script);
		self.afterLoadScript();
		
	};


	this.addMarker = function (marker) {
		if (!marker.id) {
			marker.id = self.markers.length;
		}
		self.markers.push(marker);
		return self.markers.length;
	};

	/*
	 * fare overloading di questa funzione se si vuole settare opzioni particolari
	 */
	this.afterInitialize = function() {
		return ;
	};
	this.afterLoadScript = function () {
		return ;
	};

	this.deleteMarker = function (index) {
		if (self.markers[index]) {
			if (self.markers[index].googlem !== null) {
				google.maps.event.clearListeners(self.markers[index].googlem, 'click');
				self.markers[index].googlem.setMap(null);
			}
			self.markers.splice(index, 1);
			return true;
		}
		log.warn("indice non trovato " + index);
		return false;
	};

	this.hideMarker = function (index) {
		if (self.markers[index] && self.markers[index].googlem !== null) {
			self.markers[index].googlem.setMap(null);
		}
	};
	
	this.showMarker = function (index) {
		if (self.markers[index] && self.markers[index].googlem !== null) {
			var gm = self.markers[index].googlem;
			gm.setMap(self.gmap);
			gm.setTitle(self.markers[index].title);
			gm.setPosition( new google.maps.LatLng(self.markers[index].lat, self.markers[index].lng));
			if (self.markers[index].infoWindow) {
				self.markers[index].infoWindow.setContent(self.markers[index].txt);
			}
		}
	};
	
	this.deleteAllMarkers = function () {
		var self = this;
		for (var i=0;i<self.markers.length;i++) {
			google.maps.event.clearListeners(self.markers[i].googlem, 'click');
			self.markers[i].googlem.setMap(null);
		}
		self.current = 0;
		self.markers = [];
	};
	
	this.updateMarker = function (index,values) {
		//console.log(self.markers[index]);

		if (self.markers[index] && self.markers[index].googlem !== null) {
			if (values.address) {
				self.current = index;
				self.showAddress(values.address,self.markers[index]);
			} else {
				var m = self.markers[index].googlem;
				var newLatLng = new google.maps.LatLng(values.lat, values.lng);
				//if (values.lat)
				//	m.position.lat(values.lat);
				//if (values.lng)
				//	m.position.lng(values.lng);
				m.setPosition(newLatLng);
			}
		}
	};
	this.hidePath = function () {
		self.directionsDisplay.setMap(null);
	}
	this._showPath = function (sIndex, eIndex,middlePoints,travelMode, callback) {
		/*
	    google.maps.TravelMode.DRIVING (Default) indicates standard driving directions using the road network.
	    google.maps.TravelMode.BICYCLING requests bicycling directions via bicycle paths & preferred streets.
	    google.maps.TravelMode.TRANSIT requests directions via public transit routes.
	    google.maps.TravelMode.WALKING requests walking directions via pedestrian paths & sidewalks.
*/
		try {
			if (!travelMode)
				travelMode = google.maps.TravelMode.DRIVING;
			if (!self.directionsService) {
				self.directionsService = new google.maps.DirectionsService();
			}
			if (self.directionsPanelId)
				self.directionsDisplay.setPanel(document.getElementById(self.directionsPanelId));
			self.hidePath();
			var start = self.markers[sIndex].googlem.position;
			var end = self.markers[eIndex].googlem.position;
			var waypoints = [];
			for (var i in middlePoints) {
				waypoints.push({location:middlePoints[i],stopover:true});
			}
			var request = {
					origin:start,
					destination:end,
					travelMode:  travelMode,
					waypoints : waypoints
			};
			self.directionsService.route(request, function(response, status) {
				console.log("DIRECTIONSERVICE",response,status);
				switch(status) {
				case google.maps.DirectionsStatus.OK:
					self.directionsDisplay.setMap(self.gmap);
					self.directionsDisplay.setDirections(response);
					var legs_length = response.routes[0].legs.length;
					for (var i in response.routes[0].legs) {
						self.markers[i].route_address = response.routes[0].legs[i].start_address;
					}
					self.markers[legs_length].route_address = response.routes[0].legs[legs_length-1].end_address;
					break;
				default:
					$(self.directionsDisplay.getPanel()).html($.translate("percorso_non_trovato"));
					for (var i in self.markers)
						self.markers[i].route_address = null;
					/*
					 *     NOT_FOUND indicates at least one of the locations specified in the request's origin, destination, or waypoints could not be geocoded.
					    ZERO_RESULTS indicates no route could be found between the origin and destination.
					    MAX_WAYPOINTS_EXCEEDED indicates that too many DirectionsWaypoints were provided in the DirectionsRequest. The maximum allowed waypoints is 8, plus the origin, and destination. Google Maps API for Work customers are allowed 23 waypoints, plus the origin, and destination. Waypoints are not supported for transit directions.
					    INVALID_REQUEST indicates that the provided DirectionsRequest was invalid. The most common causes of this error code are requests that are missing either an origin or destination, or a transit request that includes waypoints.
					    OVER_QUERY_LIMIT indicates the webpage has sent too many requests within the allowed time period.
					    REQUEST_DENIED indicates the webpage is not allowed to use the directions service.
					    UNKNOWN_ERROR indicates a directions request could not be processed due to a server error. The request may succeed if you try again.


					 */
					break;
				}
				/*
				if (status == google.maps.DirectionsStatus.OK) {
					self.directionsDisplay.setMap(self.gmap);
					self.directionsDisplay.setDirections(response);
			    } else {
			    	self.directionsDisplay.setMap(null);
			    }
			    */
				callback({msg:'',error:0,response:response})
			});
		} catch(e) {
			log.error(e.message);
			callback({msg:e.message,error:1,response:[]})
		}
	};
	this.showPath = function (sIndex, eIndex,travelMode,callback) {
		self._showPath(sIndex, eIndex, [], travelMode, function (result) {
			if (callback)
				callback(result);
		});
	};
	
	this.showPaths = function (sIndex, eIndex,middlePoints,travelMode,callback) {
		self._showPath(sIndex, eIndex, middlePoints, travelMode, function (result) {
			if (callback)
				callback(result);
		});
	};

	this.showArea = function(data) {
		var self = this;
		self.hideArea();

        for (var i=0;i<self.markers.length;i++) {
        	console.log(self.markers[i]);
            var cityCircle = new google.maps.Circle({
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                map: self.gmap,
                center: { 'lat':self.markers[i].lat, 'lng': self.markers[i].lng},
                radius: data.raggio
            });
            self.areas.push(cityCircle);
        }
            // Add the circle for this city to the map.
	}

	this.hideArea = function() {
		var self = this;
        for (var i=0;i<self.areas.length;i++) {
			self.areas[i].setMap(null);
        }
        self.areas = [];
	}

	this.updateArea = function (index) {
		var self  =this;
        if (index < self.areas.length) {
            self.areas[index].setCenter({ 'lat':self.markers[index].lat, 'lng': self.markers[index].lng});
        }
    }
	this.getMarker = function (index) {
		if (index < self.markers.length) {
			return self.markers[index];
		}
		return null;
	};

	this.getIndexById = function (marker_id) {
		for (var i=0;i<self.markers.length;i++)
			if (self.markers[i].id == marker_id)
				return i;
		return -1;
	};

	this.getMarkerById = function (marker_id) {
		var index = self.getIndexById(marker_id);
		return self.getMarker(index);
	};

	this.markerToCenter = function (index) {
		if (index >= self.markers.length) {
			log.warn("index:"+index+" out of range, size:"+self.markers.length);
			return ;
		}
		// se il marker e' gia stato creato
		if (self.markers[index].googlem) {
			var point = self.markers[index].googlem.position;
			
		} else {
			var point = new google.maps.LatLng(self.markers[index].lat, self.markers[index].lng)

		}
		//console.log('point',point);
		self.gmap.setCenter(point);
	};

	this.setCenter = function (lat,lng) {
		var point = new google.maps.LatLng(lat, lng);
		self.gmap.setCenter(point);
	};

	this.setCenterToMarkers = function (zoom) {
		var bounds = new google.maps.LatLngBounds();
		var foundIt = false;
		for(var i=0;i<self.markers.length;i++) {
			if (self.markers[i].googlem === null) {
				log.warn("google pointer null with index:" + i);
				continue;
			}
			if (self.markers[i].googlem.getMap()) {
				bounds.extend(self.markers[i].googlem.getPosition());
				foundIt = true;
			}
		}
		if (!foundIt)
			return ;
		zoomChangeBoundsListener = 
	        google.maps.event.addListener(self.gmap, 'bounds_changed', function(event) {
	        	//console.log("bounds_changed",zoom,self.gmap.getZoom());
	        	if (zoom) {
	        		if (self.gmap.getZoom() > zoom) {
	        			//console.log("setZoom");
	        			self.gmap.setZoom(zoom);
	        		}
	        	}
	        	/*
	            if (this.getZoom() > 15 && this.initialZoom == true) {
	                // Change max/min zoom here
	                this.setZoom(15);
	                this.initialZoom = false;
	            }
	            */
	        	google.maps.event.removeListener(zoomChangeBoundsListener);
	        });
	        
		self.gmap.fitBounds(bounds);
	};

	this.loadMarkerWithLabelScript = function (callback) {
		var s = document.createElement('script');
	    s.src = self.markerLabelScript;
	    s.async = true;
	    s.onreadystatechange = s.onload = function() {
	    	console.log("LOAD SCRIPT",s.readyState);
	        var state = s.readyState;
	        callback();
	        /* boh
	        if (!callback.done && (!state || /loaded|complete/.test(state))) {
	            callback.done = true;
	            callback();
	        }
	        */
	    };
	    document.getElementsByTagName('head')[0].appendChild(s);
	};

	// ----- events  --- 
	this.zoom_changed = function() {
		// override this event
	};

	this.showMarkersEnd = function () {
		// override this event
	};

	this.markerDragend = function (position,marker) {
		// override this event
	};

	this.markerPositionUpdated = function (gmarker) {
		// override this event
	};
	
	this.bounds_changed = function (event) {
		// override this event
	};
}


